export const locales = [
  "en",
  "ru",
] as const

export const defaultLocale = "ru" as const satisfies AppLocale

export type AppLocale = (typeof locales)[number]

/**
 * Locales written right-to-left. Add new ones here only — every dir-aware
 * consumer (`<html dir>`, Radix roots, motion offsets) reads this.
 */
export const rtlLocales = [] as const satisfies readonly AppLocale[]

export type LocaleDirection = "ltr" | "rtl"

export const getLocaleDir = (locale: string): LocaleDirection =>
  (rtlLocales as readonly string[]).includes(locale) ? "rtl" : "ltr"

export type Locale = {
  code: string
  name: string
}

export const localeLabels: Record<AppLocale, string> = {
  en: "English",
  ru: "Русский",
}

export const appLocales: Locale[] = locales.map((code) => ({
  code,
  name: localeLabels[code],
}))

export function isAppLocale(
  value: string | null | undefined
): value is AppLocale {
  return !!value && locales.includes(value as AppLocale)
}

export function matchBrowserLocale(
  acceptLanguage: string | null | undefined
): AppLocale | undefined {
  if (!acceptLanguage) return undefined

  const primary = acceptLanguage
    .split(",")[0]
    .trim()
    .split(";")[0]
    .split("-")[0]
    .toLowerCase()

  return isAppLocale(primary) ? primary : undefined
}
